import React from 'react';
import styled from 'styled-components';
// import { Link } from 'gatsby';
//import tw from 'tailwind.macro';
import tw from 'twin.macro';
import { Dot } from '../../styles/GlobalStyles';

// const ProgramBox = styled.div`
//   /* ${tw`w-full flex text-xl flex-wrap sm:flex-nowrap`} */
//   ${tw``}
// `;

const ProgramHour = styled.div`
  ${tw`w-full w-36 text-dv2021-600 font-bold`}
`;

const ProgramContent = styled.div`
  ${tw`mb-8`}
`;

const ProgramTitle = styled.p`
  ${tw`text-dv2021-600 uppercase font-bold mb-3`}
`;

const ProgramArticle = styled.p`
  ${tw`font-semibold leading-tight`}
`;

const ProgramAuthor = styled.p`
  ${tw`mb-2`}
`;

export default function Dan2() {
  return (
    <>
      <div>
        <p className="text-3xl font-bold text-center mt-16 mb-12">
          2<Dot>.</Dot> dan &ndash; 10<Dot>.</Dot> 6<Dot>.</Dot> 2021
        </p>
        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>8.30&ndash;10.00</ProgramHour>
          <ProgramContent className="md:col-span-6">
            Okrogla miza
            <br />
            <ProgramTitle>Neprimerne prakse v zdravstvu</ProgramTitle>
            <p>Moderator: Bojan Dobovšek</p>
            <p>Razpravljavci: Aleš Behram, Mirjan Hren, Dragan Kovačić</p>
          </ProgramContent>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>10.00&ndash;10.05</ProgramHour>
          <ProgramContent className="md:col-span-6">
            <ProgramTitle>Odmor</ProgramTitle>
          </ProgramContent>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>10.05&ndash;11.15</ProgramHour>
          <ProgramContent className="md:col-span-6">
            Sekcija
            <br />
            <ProgramTitle className="mb-4">Penologija</ProgramTitle>
            <p className="mb-3">Moderator: Igor Areh</p>
            <ProgramArticle>
              Doživljanje vpliva osebnega počutja pravosodnih policistov na varnost v zavodu
            </ProgramArticle>
            <ProgramAuthor>Miroslav Lavrič in Meta Lavrič</ProgramAuthor>
            <ProgramArticle>Zaščita zaporov pred brezpilotnimi zrakoplovi</ProgramArticle>
            <ProgramAuthor>Martin Pernišek in Primož Žnidaršič</ProgramAuthor>
            <ProgramArticle>
              Delo s povzročitelji nasilja v Zavodih za prestajanje kazni zapora
            </ProgramArticle>
            <ProgramAuthor>Vanja Jakopin</ProgramAuthor>
            <ProgramArticle>
              Problematika oseb z duševno manjrazvitostjo in duševnimi motnjami v ZPKZ Ig
            </ProgramArticle>
            <ProgramAuthor>Kristina Sečnik in Andreja Demšar</ProgramAuthor>
            <ProgramArticle>
              Varnostni vidiki in izzivi v Zavodu za prestajanje mladoletniškega zapora in kazni
              zapora Celje v času epidemije covida-19
            </ProgramArticle>
            <ProgramAuthor>Teja Žučko</ProgramAuthor>
            <ProgramArticle>
              Ocenjevanje tveganja ponovitve kaznivega dejanja pri spolnih prestopnikih
            </ProgramArticle>
            <ProgramAuthor>Lana Rupar in Igor Areh</ProgramAuthor>
          </ProgramContent>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>11.15&ndash;11.20</ProgramHour>
          <ProgramContent className="md:col-span-6">
            <ProgramTitle>Odmor</ProgramTitle>
          </ProgramContent>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>11.20&ndash;12.50</ProgramHour>
          <ProgramContent className="md:col-span-6">
            Okrogla miza
            <br />
            <ProgramTitle>
              Učinkovitost sistemskega nadzora nad policijo na področju spoštovanja človekovih
              pravic ter zakonskih in strokovnih standardov policijskega dela – predstavitev
              zaključnega poročila ciljnega raziskovalnega projekta V5-1942
            </ProgramTitle>
            <p>Moderator: Benjamin Flander</p>
            <p>Razpravljavci: Maja Modic, Branko Lobnikar, Bojan Tičar</p>
          </ProgramContent>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>12.50&ndash;12.55</ProgramHour>
          <ProgramContent className="md:col-span-6">
            <ProgramTitle>Odmor</ProgramTitle>
          </ProgramContent>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>12.55&ndash;14.45</ProgramHour>
          <ProgramContent className="md:col-span-6">
            Sekcija
            <br />
            <ProgramTitle className="mb-4">
              Policijska dejavnost in kriminalistično preiskovanje
            </ProgramTitle>
            <p className="mb-2">Moderatorka: Maja Modic</p>
            <ProgramArticle>
              Samozaznava legitimnosti policistov v urbanih in ruralnih okoljih
            </ProgramArticle>
            <ProgramAuthor>Gorazd Meško in Rok Hacin </ProgramAuthor>
            <ProgramArticle>
              Samomori v slovenski policiji in organizacijski izzivi v policiji
            </ProgramArticle>
            <ProgramAuthor>Bruno Blažina</ProgramAuthor>
            <ProgramArticle>Barnahus – hiša za otoke v Sloveniji</ProgramArticle>
            <ProgramAuthor>Neža Miklič</ProgramAuthor>
            <ProgramArticle>Identifikacija prstnih sledi na lateks rokavicah</ProgramArticle>
            <ProgramAuthor>Saša Vrhovec Hartman in Matej Trapečar</ProgramAuthor>
            <ProgramArticle>Forenzični intervju z otrokom v Hiši za otroke</ProgramArticle>
            <ProgramAuthor>Neža Miklič</ProgramAuthor>
            <ProgramArticle>
              Policijski postopki z osebami z motnjami avtističnega spektra
            </ProgramArticle>
            <ProgramAuthor>Matej Berglez</ProgramAuthor>
            <ProgramArticle>Kriminaliteta zoper vodo in policijska dejavnost</ProgramArticle>
            <ProgramAuthor>Katja Eman in Gorazd Meško</ProgramAuthor>
            <ProgramArticle>
              Možnosti preoblikovanja Mestnega redarstva Mestne občine Ljubljana – ugotovitve
              raziskave
            </ProgramArticle>
            <ProgramAuthor>Andrej Sotlar, Branko Lobnikar in Maja Modic</ProgramAuthor>
            <ProgramArticle>
              O (ne)ustavnosti omejitev gibanja med epidemijo covida-19
            </ProgramArticle>
            <ProgramAuthor>Benjamin Flander in Jona Koren Fric</ProgramAuthor>
          </ProgramContent>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>14.45&ndash;14.50</ProgramHour>
          <ProgramContent className="md:col-span-6">
            <ProgramTitle>Odmor</ProgramTitle>
          </ProgramContent>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>14.50&ndash;16.20</ProgramHour>
          <ProgramContent className="md:col-span-6">
            Okrogla miza
            <br />
            <ProgramTitle className="mb-4">
              Stroga razmejitev ali razvoj soodvisnosti delovanja zasebnovarnostnih subjektov in
              javne policijske dejavnosti v Sloveniji{' '}
            </ProgramTitle>
            <p className="mb-2">Moderatorka: Kaja Prislan</p>
            <p className="mb-2">
              Razpravljavci: Andrej Sotlar, Miha Dvojmoč, Miroslav Žaberl, Branko Lobnikar
            </p>
          </ProgramContent>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>16.20&ndash;16.25</ProgramHour>
          <ProgramContent className="md:col-span-6">
            <ProgramTitle>Odmor</ProgramTitle>
          </ProgramContent>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>16.25&ndash;17.15</ProgramHour>
          <ProgramContent className="md:col-span-6">
            Sekcija
            <br />
            <ProgramTitle className="mb-4">Kriminologija</ProgramTitle>
            <p className="mb-2">Moderatorka: Katja Eman</p>
            <ProgramArticle>Strah pred kriminaliteto v Ljubljani</ProgramArticle>
            <ProgramAuthor>Nastja Zadnik in Gorazd Meško</ProgramAuthor>
            <ProgramArticle>Vpliv medijev na sekundarno viktimizacijo</ProgramArticle>
            <ProgramAuthor>Megi Ahac in Tinkara Pavšič Mrevlje</ProgramAuthor>
            <ProgramArticle>
              Spolno nadlegovanje na območjih nočnega življenja v Sloveniji – pilotska študija
            </ProgramArticle>
            <ProgramAuthor>Tinkara Bulovec in Katja Eman</ProgramAuthor>
            <ProgramArticle>Kmetje in kriminaliteta v Pomurju</ProgramArticle>
            <ProgramAuthor>Katja Eman</ProgramAuthor>
          </ProgramContent>
        </div>{' '}
        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>17.15&ndash;17.20</ProgramHour>
          <ProgramContent className="md:col-span-6">
            <ProgramTitle>Odmor</ProgramTitle>
          </ProgramContent>
        </div>{' '}
        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>17.20&ndash;19.00</ProgramHour>
          <ProgramContent className="md:col-span-6">
            Sekcija
            <br />
            <ProgramTitle className="mb-4">Doktorski študenti FVV UM</ProgramTitle>
            <p className="mb-2">Moderator: Branko Lobnikar</p>
            <ProgramArticle>
              Spolno nasilje in nadlegovanje na območjih nočnega življenja – sistematični pregled
              literature
            </ProgramArticle>
            <ProgramAuthor>Tinkara Bulovec in Katja Eman</ProgramAuthor>
            <ProgramArticle>
              Ekološko kriminološki diskurz o kriminogenosti oboroženih sil
            </ProgramArticle>
            <ProgramAuthor>Silvo Grčar, Katja Eman in Andrej Sotlar</ProgramAuthor>
            <ProgramArticle>
              Nasilje nad starši in nasilje nad starejšimi: povezanost, podobnosti in razlike
            </ProgramArticle>
            <ProgramAuthor>Monika Klun, Aleš Bučar Ručman in Danijela Frangež</ProgramAuthor>
            <ProgramArticle>
              4. mednarodna študija o mladoletniškem prestopništvu: International Self-Report
              Delinquency (ISRD4)
            </ProgramArticle>
            <ProgramAuthor>Iza Kokoravec in Gorazd Meško</ProgramAuthor>
            <ProgramArticle>
              Relevantnost funkcije pomožne policije v Republiki Sloveniji in možnost njene
              vključitve v varovanje državne meje
            </ProgramArticle>
            <ProgramAuthor>Jasmina Pinoza, Maja Modic in Aleš Bučar Ručman</ProgramAuthor>
            <ProgramArticle>
              Analiza relevantnosti proučevanja nasilja nad starejšimi v institucionalnem in domačem
              okolju: sistematični pregled literature
            </ProgramArticle>
            <ProgramAuthor>Teja Primc, Branko Lobnikar in Kaja Prislan</ProgramAuthor>
            <ProgramArticle>
              Analiza orodij za pridobivanje podatkov iz javnih virov (OSINT) za namen konkurenčne
              obveščevalne dejavnosti
            </ProgramArticle>
            <ProgramAuthor>Žiga Primc</ProgramAuthor>
            <ProgramArticle>
              Razhajanje med oceno stanja in pričakovanji prebivalcev do institucij pluralne
              policijske dejavnosti glede zagotavljanja varnosti
            </ProgramArticle>
            <ProgramAuthor>Franc Virtič in Branko Lobnikar</ProgramAuthor>
          </ProgramContent>
        </div>{' '}
        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>19.00</ProgramHour>
          <ProgramContent className="md:col-span-6">
            <ProgramTitle>Zaključek konference</ProgramTitle>
          </ProgramContent>
        </div>{' '}
      </div>
    </>
  );
}
